var chunkToChildrenMap = {
	"7547": [
		3215,
		8689,
		75,
		6512,
		8495,
		9924,
		448,
		1956,
		918
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));